var map = {
	"./children.png": "d69b",
	"./chronic.png": "7bbb",
	"./circlesB1.png": "bb53",
	"./colored_circles-4-mob.png": "7380",
	"./colored_circles-4.png": "8cb1",
	"./colored_circles-5-mob.png": "119a",
	"./colored_circles-5.png": "048d",
	"./flu-virus-1.png": "15b2",
	"./flu-virus-2.png": "9c34",
	"./fromM.png": "be14",
	"./map.png": "515b",
	"./mob.png": "9a1c",
	"./mobRedImg.png": "66c4",
	"./oldest.png": "86e7",
	"./pregnant.png": "1566",
	"./profGroup.png": "eb20",
	"./tooltip-girl-2.png": "cc9b",
	"./tooltip-girl-3.png": "fc0d",
	"./tooltip-girl.png": "b697"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "15fa";